//GeneratorFlag:[NoChange]
export default {
	path: 'city',
	name: 'hub.geographical.city.layout',
	redirect: to => {
		return {name: 'hub.city.list'};
	},
	component: () => import('@/modules/hub/views/layout.vue'),
	meta: {
		requiresAuth: true,
		serverAccessKeys:[],
		clientAccessKeys:["/hub/geographical/city"],
		resourceKey: 'hub.cityLayout',
		menuConfig: {
			isVisible: true,
			iconName: 'bi-geo-fill',
		}
	},
	children: [
//GeneratorFlag:[CityCreate]"
		{
			path: 'create',
			name: 'hub.city.create',
			component: () => import('@/modules/hub/views/city/city-create.vue'),
			meta: {
				requiresAuth: true,
				resourceKey: 'hub.cityCreate',
				clientAccessKeys:["/hub/geographical/city/create"],
				serverAccessKeys:["/hub/city/create","/hub/city/stream-create"],
				menuConfig: {
					isVisible: false
				}
			}
		},
//GeneratorFlag:[CityCreateImport]"
		{
			path: 'create-import',
			name: 'hub.city.createImport',
			component: () => import('@/modules/hub/views/city/city-create-import.vue'),
			meta: {
				requiresAuth: true,
				resourceKey: 'hub.cityCreateImport',
				clientAccessKeys:["/hub/geographical/city/create-import"],
				serverAccessKeys:["/hub/city/create","/hub/city/stream-create"],
				menuConfig: {
					isVisible: false
				}
			}
		},
//GeneratorFlag:[CityDelete]"
		{
			path: 'delete',
			name: 'hub.city.delete',
			component: () => import('@/modules/hub/views/city/city-delete.vue'),
			meta: {
				requiresAuth: true,
				resourceKey: 'hub.cityDelete',
				clientAccessKeys:["/hub/geographical/city/delete"],
				serverAccessKeys:["/hub/city/delete","/hub/city/stream-delete"],
				menuConfig: {
					isVisible: false
				}
			}
		},
//GeneratorFlag:[CityDetail]"
		{
			path: 'detail',
			name: 'hub.city.detail',
			component: () => import('@/modules/hub/views/city/city-detail.vue'),
			meta: {
				requiresAuth: true,
				resourceKey: 'hub.cityDetail',
				clientAccessKeys:["/hub/geographical/city/detail"],
				serverAccessKeys:["/hub/city/detail"],
				menuConfig: {
					isVisible: false
				}
			}
		},
//GeneratorFlag:[CityList]"
		{
			path: 'list',
			name: 'hub.city.list',
			component: () => import('@/modules/hub/views/city/city-list.vue'),
			meta: {
				requiresAuth: true,
				resourceKey: 'hub.cityList',
				clientAccessKeys:["/hub/geographical/city/list"],
				serverAccessKeys:["/hub/city/list"],
				menuConfig: {
					isVisible: false
				}
			}
		},
//GeneratorFlag:[CityAttachment]"
		{
			path: 'attachment',
			name: 'hub.city.attachment',
			component: () => import('@/modules/hub/views/city/city-attachment.vue'),
			meta: {
				requiresAuth: true,
				resourceKey: 'hub.cityAttachment',
				clientAccessKeys:["/hub/geographical/city/attachment"],
				serverAccessKeys:["/hub/city/list"],
				menuConfig: {
					isVisible: false
				}
			}
		},
//GeneratorFlag:[CityUpdate]"
		{
			path: 'update',
			name: 'hub.city.update',
			component: () => import('@/modules/hub/views/city/city-update.vue'),
			meta: {
				requiresAuth: true,
				resourceKey: 'hub.cityUpdate',
				clientAccessKeys:["/hub/geographical/city/update"],
				serverAccessKeys:["/hub/city/update"],
				menuConfig: {
					isVisible: false
				}
			}
		},
//GeneratorFlag:[NewRoute]
	]
}